@if (expandMenuDrawer$ | async) {}
@if (gridView$ | async; as view) {

  <div class="st-top-bar flex justify-content-between">
    @if (view === "medium" || view === "small") {
      <div class="show-hide-toggle">
        <button
          [ngClass]="{ active: this.isExpand() }"
          (click)="expandDrawer()"
          title="Toggle sidebar menu"
          aria-label="Toggle sidebar menu"
        >
          <em class="icon-sidebar"></em>
        </button>
      </div>
    }
    <div
      class="st-top-bar-content flex-1 flex align-items-center justify-content-between ml-auto"
    >
      <div class="align-self-end flex-1">
        @if (view !== "medium" && view !== "small") {
          <st-top-header-tabs></st-top-header-tabs>
        }
      </div>
      <st-top-header-right-section>
        <div ngProjectAs="notification-section">
          <ng-content select="top-header-notification-section"></ng-content>
        </div>
        <div ngProjectAs="top-filters-section">
          <ng-content select="top-header-filters-section"></ng-content>
        </div>
      </st-top-header-right-section>
    </div>
  </div>

}
